module.exports = __webpack_public_path__ + "img/bannerh_desktop.6fb312d5.png";